import React from 'react';

const CARDS = [
  {
    label: 'Our Vision',
    body:  "India's most accessible and intelligent workforce ecosystem — bridging talent, opportunities, colleges, recruiters and businesses through one platform.",
  },
  {
    label: 'Our Mission',
    body:  "Use technology and AI to eliminate the fragmentation in India's hiring ecosystem, so every kind of worker gets equal access to the right opportunity.",
  },
  {
    label: 'Our Purpose',
    body:  "Make every kind of work — white-collar, blue-collar, government, contract — discoverable and accessible to every Indian, in their own language.",
  },
];

export default function VisionMissionPurpose() {
  return (
    <section className="py-14 md:py-24 px-4 sm:px-6 bg-ink-900">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl text-white
                       tracking-tight text-center mb-10 md:mb-14">
          What drives us
        </h2>
        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {CARDS.map(card => (
            <div key={card.label}
                 className="p-6 md:p-8 rounded-3xl border border-white/10 bg-white/5">
              <h3 className="font-display font-bold text-xl text-brand-saffron mb-4">
                {card.label}
              </h3>
              <p className="text-white/70 text-base leading-relaxed">{card.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
